import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { Html5QrcodeScanner } from "html5-qrcode"
import { Loggable } from "./concerns/loggable"
import { CsrfTokenable } from "./concerns/csrf-tokenable";

export default class extends Controller {
  static targets = ["reader"]

  initialize() {
    Loggable(this, { debug: true })
    CsrfTokenable(this)
  }

  connect() {
    // Guard flags to allow quick rescanning without spamming the server
    this.processing = false
    this.lastScan = { text: null, time: 0 }

    this.scanner = new Html5QrcodeScanner(
      this.readerTarget.id,
      { fps: 10, qrbox: { width: 250, height: 250 } },
      /* verbose= */ false
    );
    this.scanner.render(this.onScanSuccess.bind(this), this.onScanFailure.bind(this));
  }

  disconnect() {
    if (this.scanner) {
      this.scanner.clear().catch(error => {
        console.error("Failed to clear html5-qrcode scanner. ", error);
      });
    }
  }

  onScanSuccess(decodedText, decodedResult) {
    // Handle the scanned code as you like, for example:
    console.log(`Code matched = ${decodedText}`, decodedResult);

    // Throttle duplicate scans and avoid concurrent requests
    const now = Date.now()
    if (this.processing) return
    if (this.lastScan.text === decodedText && now - this.lastScan.time < 1500) return

    this.processing = true
    this.lastScan = { text: decodedText, time: now }

    // Keep scanner visible for quick rescanning; do NOT clear it here
    this.sendQrCode(decodedText)
      .finally(() => {
        // Small cooldown to prevent flooding
        setTimeout(() => { this.processing = false }, 500)
      })
  }

  onScanFailure(error) {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    // console.warn(`Code scan error = ${error}`);
  }

  sendQrCode(code) {
    const csrfToken =  this.getCsrfToken()

    return fetch("/teacher_panel/qr_reader", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/html, application/json"
      },
      body: JSON.stringify({ qr_code: code })
    })
    .then(async response => {
      const contentType = response.headers.get("Content-Type") || ""

      if (response.redirected) {
        window.location.href = response.url
        return
      }

      if (contentType.includes("text/vnd.turbo-stream.html")) {
        const stream = await response.text()
        Turbo.renderStreamMessage(stream)
        return
      }

      // Fallback: try to parse text and log
      const text = await response.text()
      console.log("Non-turbo response received", text)
    })
    .catch(error => {
      console.error("Error sending QR code:", error)
    })
  }
}
